import React, { useMemo } from 'react';
import { determinePossibleGlobalFilterValues } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { doesFilterStoreValueContainItem } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { SecondaryFilterSelection } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { FilterSetDefinitionWithValues } from 'libs/end-to-end/src/types/databases/filters/filter-definition';
import { SearchableFilterListBox } from 'apps/sigma2-ui/src/filters-v2/components/SearchableFilterListBox';
import { MyObservation } from 'libs/end-to-end/src/my-observation';
import { FilterStoreValue } from 'libs/end-to-end/src/filters-v2/types/filters-v2.types';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const GlobalFilterContent = ({
  stagingGlobalFilters,
  setStagingGlobalFilter,
  filterKey,
  globalFilterDefinitions,
  myObservation,
}: {
  filterKey: string;
  globalFilterDefinitions: FilterSetDefinitionWithValues['filterDefinitions'];
  stagingGlobalFilters: SecondaryFilterSelection[];
  setStagingGlobalFilter: (params: {
    secondaryFilterKey: string;
    value: FilterStoreValue;
  }) => void;
  myObservation: MyObservation | null;
}) => {
  const language = useLanguage();

  return useMemo(() => {
    const definition = globalFilterDefinitions.find(
      (definition) => definition.columnHeaderValue === filterKey,
    );

    if (!definition) {
      return null;
    }

    const possibleValues = determinePossibleGlobalFilterValues({
      filterKey,
      myObservation,
      stagingGlobalFilters,
    });

    return (
      <SearchableFilterListBox
        items={possibleValues.map((value) => {
          // if the value has a display mapped value, use that for the display instead
          const displayValue =
            definition.optionalDisplayValues?.[value] ?? value;

          return {
            translatedContent: language.dangerousUserInput({
              value: displayValue,
            }),
            value,
            selected: stagingGlobalFilters.some(
              (item) =>
                item.secondaryFilterKey === filterKey &&
                doesFilterStoreValueContainItem(item.value, value),
            ),
          };
        })}
        multiple={true}
        onChange={(newItems) => {
          setStagingGlobalFilter({
            secondaryFilterKey: filterKey,
            value: newItems,
          });
        }}
      />
    );
  }, [
    myObservation,
    globalFilterDefinitions,
    filterKey,
    setStagingGlobalFilter,
    stagingGlobalFilters,
    language,
  ]);
};
